import { useMutation, useQuery } from '@apollo/react-hooks'
import USER_RATING_QUERY from '../../../graphql/queries/user-rating.gql'
import UPDATE_USER_RATING_MUTATION from '../../../graphql/mutations/update-user-rating.gql'

export const useUserRatingQuery = ({
  skip = false,
  contentItemId,
  setRating
}) => {
  const { loading, error, data: userRatingQueryData } = useQuery(USER_RATING_QUERY, {
    skip,
    variables: { input: { contentItemId } },
    onCompleted: data => {
      setRating && setRating(data.userRating)
    },
    onError: err => {
      console.error(`query userRating error`, err)
    },
    fetchPolicy: 'cache-first'
  })
  return {
    userRatingQueryLoading: loading,
    userRatingQueryError: error,
    userRatingQueryData
  }
}

export const useUserRatingMutation = ({
  skip = false,
  setRating
}) => {
  const [userRatingMutation, { loading, error, data: userRatingMutationData }] = useMutation(
    UPDATE_USER_RATING_MUTATION,
    {
      skip,
      // update cache after successful mutation
      update(cache, { data: { updateUserRating } }) {
        if (updateUserRating) {
          cache.writeQuery({
            query: USER_RATING_QUERY,
            variables: { input: { contentItemId: updateUserRating.contentItemId } },
            data: { userRating: updateUserRating }
          })
        }
      },
      onCompleted: data => {
        setRating && setRating(data.updateUserRating)
      },
      onError: err => {
        console.error(`mutation updateUserRating error`, err)
      }
    }
  )
  return {
    userRatingMutation,
    userRatingMutationLoading: loading,
    userRatingMutationError: error,
    userRatingMutationData
  }
}
